import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pos-spinner',
  templateUrl: './pos-spinner.component.html',
  styleUrls: ['./pos-spinner.component.sass']
})
export class PosSpinnerComponent implements OnInit {

  @Input()
  show: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
